import aa from "search-insights";
import type { AutocompleteItem } from "./types";

export function trackAutocompleteViews({
  autocompleteState,
  viewedProducts,
  indexName,
  aaClient = aa,
}: {
  autocompleteState: {
    collections: Array<{
      source: { sourceId: string };
      items: AutocompleteItem[];
    }>;
    isOpen: boolean;
  };
  viewedProducts?: { items: AutocompleteItem[] };
  indexName: string;
  aaClient: typeof aa;
}) {
  if (autocompleteState.collections.length === 0) return;

  const autocompleteOpen = autocompleteState.isOpen;

  // Track main products index views
  const productsCollection = autocompleteState.collections.find(
    (collection) => collection.source.sourceId === "products"
  );

  if (autocompleteOpen && productsCollection?.items.length > 0) {
    aaClient("viewedObjectIDs", {
      index: indexName,
      eventName: "autocomplete_items_viewed",
      objectIDs: productsCollection.items.map((item) => item.objectID),
    });
  }

  // Track query suggestions index views
  if (autocompleteOpen && viewedProducts?.items.length > 0) {
    aaClient("viewedObjectIDs", {
      index: `${indexName}_query_suggestions`,
      eventName: "autocomplete_items_viewed",
      objectIDs: viewedProducts.items.map((item) => item.objectID),
    });
  }
}
